import {
  getAcgmeTemplateSection,
  getBiosketchSection,
  getHomeSetup,
  scholarshipSetup
} from "../customSections/index.js";
import {
  generateSectionsFromSectionsArray,
  sortField
} from "../lib/cvDataUtilities.js";
import { getDate, isTodayWithinRange } from "../lib/dateHelpers.js";
import {
  getCitation,
  getCitationLabel,
  getExtraPINameField,
  getFormatted,
  getIndex,
  getPMIDduplicate,
  getText,
  mergeItems,
  previewSection,
  previewSections,
  scholarshipAdvancedImportTrim,
  serialize,
  serverACGMEResult
} from "../lib/formatUtilities.js";
import { escapeHtml, htmlToXML } from "../lib/frontendUtilities.js";
import { anyPathOverlap } from "../lib/hierarchyUtilities.js";
import { getField, getKey, keys } from "../lib/utilities.js";

export function hopkinsSettingsSetup(logoOptions) {
  let hopkinsLogo = logoOptions;
  return function (contextMethods, contextConstants, contextState) {
    let { refreshSection } = contextMethods;
    let { canEdit, newDef } = contextState;

    $("#fieldList").append(
      $(
        '<div style="display: inline-block; width: 100%;">' +
          '  <h4 style="margin-top: 30px; margin-bottom: 10px;display: inline-block;">' +
          '<span class="hopkinsLogoTitle">John Hopkins Logo</span>' +
          "  </h4>" +
          '  <select style="display: inline-block;width: auto;margin-left: 10px;" class="form-control hopkinsLogo">' +
          keys(hopkinsLogo)
            .map(function (line) {
              return (
                '<option value="' +
                line +
                '">' +
                hopkinsLogo[line] +
                "</option>"
              );
            })
            .join("") +
          "  </select>" +
          "</div>"
      )
    );

    $(".hopkinsLogo").prop("disabled", !canEdit);
    let hopkinsLogoValue = getKey(
      getKey(newDef, "narrative", {}),
      "hopkinsLogo",
      hopkinsLogo[keys(hopkinsLogo)[0]]
    );
    $(".hopkinsLogoTitle").text("John Hopkins Logo");
    $(".hopkinsLogo").val(hopkinsLogoValue);
    $(".hopkinsLogo")
      .unbind("change")
      .on("change", function () {
        var area = $(this).val();
        newDef.narrative.hopkinsLogo = area;
        refreshSection();
      });
  };
}

export function hopkinsLogoOutput(option) {
  return function (cvDef, filter, opts) {
    let hopkinsLogo = getKey(getKey(cvDef, "narrative", {}), "hopkinsLogo", "");
    return option == hopkinsLogo;
  };
}

export default {
  filter: function (cvOwner, templateList) {
    return anyPathOverlap(
      templateList["hopkins"]?.paths || [],
      cvOwner.requestedPaths
    );
  },
  defaultInput: "overview",
  Title: "Hopkins Healthcare CV",
  settings: {
    disableAggregation: true
  },
  template: "/templateFiles/hopkins_template_v1_1.docx",

  customOptions: [
    {
      field: "ongoingExtended",
      name: "Ongoing Time Style",
      default: false,
      options: [
        { value: false, theme: "success", name: "Default" },
        { value: true, theme: "success", name: "- Present" }
      ]
    },
    {
      field: "includeCitations",
      name: "Citation Counts",
      default: false,
      options: [
        { value: false, theme: "success", name: "Not Added" },
        { value: true, theme: "success", name: "Added" }
      ]
    },
    {
      field: "includeRCR",
      name: "Relative Citation Ratio (RCR)",
      default: false,
      options: [
        { value: false, theme: "success", name: "Not Added" },
        { value: true, theme: "success", name: "Added" }
      ]
    },
    {
      field: "emptySections",
      name: "Empty Sections",
      default: false,
      options: [
        { value: false, theme: "success", name: "Not Included" },
        { value: true, theme: "success", name: "Included" }
      ]
    }
  ],
  input: [
    {
      field: "overview",
      icon: "home",
      type: "custom",
      title: "Settings",
      setup: getHomeSetup({
        citationNames: true,
        initialSetup: hopkinsSettingsSetup({
          non: "Not Selected",
          med: "School of Medicine",
          nurs: "School of Nursing",
          bsph: "School of Public Health"
        })
      })
    },
    {
      field: "notes",
      icon: "pencil",
      title: "Note Pad",
      type: "obj",
      topHTML:
        '<h5 style="line-height: 20px;">For your convenience, you may use this space as a note pad.<br>This will not be included in your CV.<br>Tip: Send an email to <a href="mailto:notepad@easycv.me" target="_blank">notepad@easycv.me</a> to quickly add a note here for future reference.</h5>',
      items: [{ name: "notes", label: "Notes", noHide: true, height: 600 }]
    },
    {
      field: "bio",
      title: "Personal Data",
      type: "obj",
      items: [
        { name: "name", label: "Full Name", required: true },
        {
          name: "officeAddress",
          label: "Business Address",
          required: true,
          height: 160
        },
        { name: "division", label: "Division", required: true, height: 55 },
        { name: "dept", label: "Department", required: true, height: 55 },
        {
          name: "officeLocation",
          label: "Building and Room",
          required: true,
          height: 55
        },
        { name: "workPhone", label: "Work Phone", height: 55 },
        { name: "workFax", label: "Work Fax", height: 55 },
        { name: "workEmail", label: "E-Mail", required: true, height: 55 }
      ]
    },
    {
      field: "education",
      type: "list",
      title: "Education & Training",
      optionalPreface: true,
      items: [
        {
          type: "type",
          types: [
            ["undergraduate", "Undergraduate"],
            ["graduate", "Doctoral/graduate"]
          ]
        },
        { name: "degree", label: "Degree", required: true, height: 60 },
        { name: "secondaryInfo", label: "Discipline", width: 400, height: 60 },
        {
          name: "location",
          label: "Institution / City",
          required: true,
          width: 300,
          height: 60
        },
        { name: "notes", label: "Additional Notes (Optional)", height: 60 }
      ]
    },
    {
      field: "postDoctoralTraining",
      title: "Postdoctoral Training",
      type: "list",
      optionalPreface: true,
      items: [
        {
          type: "type",
          types: [
            ["internship", "Internship"],
            ["residency", "Residency"],
            ["fellowship", "Fellowship"],
            ["other", "Other"]
          ]
        },
        { name: "degree", label: "Degree/Certificate", required: true },
        { name: "field", label: "Specialty/Discipline", required: true },
        { name: "location", label: "Institution/City", required: true },
        {
          name: "notes",
          label: "Additional Notes (Optional)",
          tip: "Indicate primary mentors for scholarly activities where applicable"
        }
      ]
    },
    {
      field: "facultyAppointments",
      title: "University Appointments",
      type: "list",
      optionalPreface: true,
      items: [
        { name: "title", label: "Position", required: true },
        { name: "location", label: "Institution, City", required: true }
      ]
    },
    {
      field: "hospitalAppointments",
      title: "Hospital Appointments",
      type: "list",
      optionalPreface: true,
      items: [
        { name: "title", label: "Position", required: true },
        { name: "location", label: "Institution, City", required: true }
      ]
    },
    {
      section: "otherAppointments",
      field: "otherPositions",
      title: "Other Appointments",
      type: "list",
      optionalPreface: true,
      items: [
        { type: "type", types: ["academic"] },
        { name: "title", label: "Position", required: true },
        { name: "location", label: "Institution, City", required: true }
      ]
    },
    {
      field: "scholarship",
      title: "Publications",
      type: "list",
      advancedDateNotRequired: true,
      setup: scholarshipSetup(),
      optionalPreface: true,
      items: [
        {
          type: "type",
          types: [
            ["Research Investigations", "Original Research"],
            ["reviews", "Review Articles"],
            ["Case reports", "Case Reports"],
            ["chapters", "Book Chapters & Monographs"],
            [
              "Books/textbooks for the medical or scientific community",
              "Books & Textbooks"
            ],
            ["editorials", "Editorials"],
            [
              "Clinical Guidelines and Reports",
              "Guidelines/Protocols, Consensus Statement, Expert Opinion, Consortium Articles"
            ],
            ["Letters to the Editor", "Letters, Correspondence"],
            ["memoirs", "Clinical Stories and Memoirs"],
            ["creativeWriting", "Creative Writing"],
            ["methods", "Methods and Techniques"],
            [
              "commentaries",
              "Opinions, Perspectives, Political Commentary, Advocacy, Essays"
            ],
            [
              "Proceedings of meetings or other non-peer reviewed scholarship",
              "Original Research, Not Peer-reviewed"
            ],
            ["proceedingsReports", "Proceedings Reports"],
            [
              "Professional educational materials or reports, in print or other media",
              "Published Curricula, Learner Assessment Tools, Educational Evaluations"
            ],
            ["policy", "White Papers"],
            ["interviews", "Media Releases or Interviews"],
            ["media", "Other Media"]
          ]
        },
        {
          name: "PMID",
          noAdvancedImport: true,
          filter: (n) =>
            [
              "Research Investigations",
              "editorials",
              "Clinical Guidelines and Reports",
              "Letters to the Editor",
              "Proceedings of meetings or other non-peer reviewed scholarship"
            ].indexOf(n.type) >= 0,
          label: function (item) {
            return (
              "PubMed ID" +
              (item.PMID == null
                ? ""
                : '<a href="https://pubmed.ncbi.nlm.nih.gov/' +
                  htmlToXML(item.PMID, { justText: true }) +
                  '" target="_blank" style="margin-left: 5px;"><span class="glyphicon glyphicon-link"></span></a>')
            );
          },
          shortLabel: "PubMed ID",
          checkErrors: function (item, cvDef) {
            let dupItem = getPMIDduplicate(item, cvDef, [
              "Research Investigations",
              "editorials",
              "Clinical Guidelines and Reports",
              "Letters to the Editor"
            ]);
            let isDuplicate = item.PMID != "" && dupItem != null;
            let dupLink =
              '<a href="#" class="jump" data-field="scholarship" data-id="' +
              (dupItem || {}).id +
              '" style="color: #ad310d;">Duplicate<span class="glyphicon glyphicon-share-alt" style="margin-left: 5px;"></span></a>';
            return isDuplicate ? dupLink : null;
          }
        },
        {
          name: "line",
          required: true,
          width: 700,
          height: 80,
          advancedImportTrim: scholarshipAdvancedImportTrim,
          label: getCitationLabel()
        },
        {
          name: "comments",
          noAdvancedImport: true,
          label: "Additional Comments (optional)"
        }
      ]
    },
    {
      field: "projects",
      title: "Funding",
      type: "list",
      optionalPreface: true,
      topHTML:
        "<h4>Instruction: In chronological order, earliest first by start date under each subcategory.  Funding type default is Extramural. Please update as appropriate.</h4>",
      items: [
        { type: "type", types: [["funded", "Funded"]] },
        {
          name: "projectFocus",
          label: "Project Focus",
          type: "select",
          options: [
            "Research",
            "Educational",
            "Clinical",
            "System Innovation or Quality Improvement",
            "Other"
          ]
        },
        { name: "dateComment", label: "Date Comment (optional)" },
        { name: "title", label: "Title", required: true },
        {
          name: "grantTypeAndNumber",
          label: "Identification Number",
          required: true
        },
        { name: "fundingSource", label: "Sponsor", required: true },
        {
          name: "sourceType",
          label: "Funding Type",
          type: "select",
          options: ["Extramural", "Intramural"]
        },
        { name: "directCosts", label: "Total Direct Cost", required: true },
        {
          name: "role",
          label: "Role",
          type: "select",
          required: true,
          allowOther: true,
          options: [
            "Not Selected",
            "Principal Investigator",
            "Co-Principal Investigator",
            "Multi-Principal Investigator",
            "Site Principal Investigator",
            "Project Principal Investigator",
            "Sub-Contract Principal Investigator",
            "Investigator",
            "Co-Investigator",
            "Consultant",
            "Mentor"
          ]
        },
        getExtraPINameField(),
        { name: "workTime", label: "Percent Effort", required: true },
        { name: "pending", label: "Pending", type: "checkbox" },
        { name: "description", label: "Additional Notes (Optional)" }
      ]
    },
    {
      section: "clinicalFocus",
      field: "researchInterests",
      title: "Clinical Focus",
      type: "obj",
      items: [
        {
          name: "clinicalFocus",
          label:
            "Provide up to a 100 word narrative, bulleted accomplishments, or key words that express your clinical focus.",
          noHide: true,
          allowFormatting: true,
          height: 600
        }
      ]
    },
    {
      section: "certification",
      field: "clinicalActivityAndInnovations",
      title: "Certification",
      type: "list",
      optionalPreface: true,
      items: [
        {
          type: "type",
          types: [
            [
              "Current Licensure and Certification",
              "Medical State/Government Licensure"
            ],
            ["certification", "Board and Specialty Certification"]
          ]
        },
        {
          name: "title",
          required: true,
          label: function (item) {
            if (item.type == "Current Licensure and Certification")
              return "State Info";
            return "Specialty Name";
          }
        },
        {
          name: "description",
          label: "Identification Number",
          required: true,
          filter: (n) => n.type != "Practice Activities"
        },
        {
          name: "workTime",
          label: "Time Commitment",
          filter: (n) => n.type == "Practice Activities"
        },
        {
          name: "description",
          label: "Specialty",
          required: true,
          filter: (n) => n.type == "Practice Activities"
        },
        { name: "comments", label: "Additional Notes (Optional)" }
      ]
    },
    {
      section: "clinicalService",
      field: "clinicalActivityAndInnovations",
      title: "Clinical (Service) Responsibilites",
      type: "list",
      optionalPreface: true,
      topHTML:
        "<h4>Instructions: Role, time commitment, specialty, explanatory notes</h4>",
      items: [
        { type: "type", types: ["Practice Activities"] },
        { name: "title", required: true, label: "Role" },
        {
          name: "description",
          label: "Identification Number",
          required: true,
          filter: (n) => n.type != "Practice Activities"
        },
        {
          name: "workTime",
          label: "Time Commitment",
          filter: (n) => n.type == "Practice Activities"
        },
        {
          name: "description",
          label: "Specialty",
          required: true,
          filter: (n) => n.type == "Practice Activities"
        },
        { name: "comments", label: "Additional Notes (Optional)" }
      ]
    },
    {
      section: "clinicalProductivity",
      field: "researchInterests",
      title: "Clinical Productivity",
      type: "obj",
      items: [
        {
          name: "clinicalProductivity",
          label:
            "Describe the annual number of patients you evaluate or treat, procedures you perform, referrals, wRVUs, or other activities.",
          noHide: true,
          allowFormatting: true,
          height: 600
        }
      ]
    },
    {
      section: "clinicalActivity",
      field: "clinicalActivityAndInnovations",
      title: "Clinical Activities",
      type: "list",
      optionalPreface: true,
      items: [
        {
          type: "type",
          types: [
            ["clinicalDraw", "Clinical Draw"],
            ["specialtyBoard", "Specialty Board Membership"],
            ["leadership", "Clinical Program Building / Leadership"],
            ["demonstrations", "Clinical Demonstration Activities"]
          ]
        },
        {
          name: "role",
          label: "Role",
          required: true,
          filter: (n) => n.type != "clinicalDraw" && n.type != "demonstrations"
        },
        {
          name: "title",
          required: true,
          tip: function (item) {
            if (item.type == "clinicalDraw")
              return "Clinical Draw from outside local/regional area (reflecting national/international reputation)";
            return "";
          },
          shortLabel: "Name",
          label: function (item) {
            if (item.type == "clinicalDraw")
              return "X of Y patients came from out-of-state, list states or countries";
            if (item.type == "demonstrations")
              return "Clinical Technique, Procedure, or Program";
            if (item.type == "specialtyBoard") return "Name of Specialty Board";
            if (item.type == "leadership") return "Name of Clinical Program";
            return "Name";
          }
        },
        {
          name: "description",
          label: "Impact Outside of JHMI/Region",
          filter: (n) => n.type == "leadership"
        },
        {
          name: "description",
          label: "Observing Party",
          required: true,
          filter: (n) => n.type == "demonstrations"
        },
        {
          name: "location",
          label: "Venue",
          required: true,
          filter: (n) => n.type == "demonstrations"
        },
        { name: "comments", label: "Additional Notes (Optional)" }
      ]
    },
    {
      section: "ClinicalCareGuidelines",
      field: "clinicalActivityAndInnovations",
      title: "Clinical Standards of Care",
      type: "list",
      tips: "May not be published in peer-reviewed journals",
      optionalPreface: true,
      items: [
        { type: "type", types: ["guidelines"] },
        {
          name: "line",
          required: true,
          width: 700,
          height: 80,
          advancedImportTrim: scholarshipAdvancedImportTrim,
          label: getCitationLabel()
        },
        { name: "comments", label: "Additional Notes (Optional)" }
      ]
    },
    {
      section: "educationalFocus",
      field: "researchInterests",
      title: "Educational Focus",
      type: "obj",
      items: [
        {
          name: "teaching",
          label:
            "Provide up to 100 word narrative, bulleted accomplishments, or key words that express your educational focus and level of impact (local, regional, national, international) in the any of the following domains: teaching and facilitating learning, mentoring, coaching and advising, assessment and evaluation, curriculum and program development, educational leadership, and educational scholarship",
          noHide: true,
          allowFormatting: true,
          height: 600
        }
      ]
    },
    {
      section: "teachingAndFacilitatingLearning",
      field: "teaching",
      title: "Teaching and Facilitating Learning",
      type: "list",
      optionalPreface: true,
      topHTML:
        "<h4>Instructions: Include date, role, learner level, course title, venue, number of learners, any explanatory notes; please separate JHMI/Regional from National and International activities</h4>",
      items: [
        {
          type: "type",
          types: [
            ["Teaching of Students in Courses", "Classroom Instruction"],
            [
              "Formal Teaching of Residents, Clinical Fellows and Research Fellows (post-docs)",
              "Clinical Instruction"
            ],
            [
              "Formal Teaching of Peers (e.g., CME and other continuing education courses)",
              "CME Instruction"
            ],
            ["external", "Workshops / Seminars"]
          ]
        },
        {
          name: "level",
          label: "Level",
          required: true,
          type: "select",
          options: [
            "Not selected",
            "JHMI",
            "Regional",
            "National",
            "International"
          ]
        },
        { name: "role", label: "Role", required: true },
        { name: "learnerLevel", label: "Learner Level", required: true },
        { name: "title", label: "Course Title", required: true },
        { name: "location", label: "Venue", required: true },
        { name: "numLearners", label: "Number of Learners", required: true },
        { name: "comments", label: "Additional Notes (Optional)" }
      ]
    },
    {
      section: "mentees",
      field: "mentoring",
      title: "Mentees",
      type: "list",
      optionalPreface: true,
      topHTML: function (contextState) {
        if (contextState.focusType == "graduate")
          return "<h4>Instructions: Mentee name, thesis title (if available), your role, any explanatory notes</h4>";
        return "<h4>Instructions: Include mentee name, degree, present position; awards/grants/degrees received under your direction, indicate shared publications with mentees as per CV Format Instructions, explanatory notes</h4>";
      },
      items: [
        {
          type: "type",
          types: [
            ["undergraduate", "Pre-Doctoral"],
            ["postdoc", "Post-Doctoral"],
            ["graduate", "Thesis Comittees"]
          ]
        },
        {
          name: "title",
          required: true,
          label: function (item) {
            if (item.type == "graduate") return "Mentee Name";
            return "Mentee Name, Degree(s)";
          }
        },
        {
          name: "position",
          label: "Present Position",
          required: true,
          filter: (n) => n.type != "graduate"
        },
        {
          name: "secondary",
          label: "Awards/Grants/Degrees recieved under direction",
          filter: (n) => n.type != "graduate"
        },
        {
          name: "description",
          label: function (item) {
            if (item.type == "graduate") return "Thesis Title";
            return "Shared Publications";
          }
        },
        {
          name: "role",
          label: "Your Role",
          required: true,
          filter: (n) => n.type == "graduate"
        },
        { name: "comments", label: "Additional Notes (Optional)" }
      ]
    },
    {
      section: "mentoringCoachingProgram",
      field: "mentoring",
      title: "Mentoring / Coaching / Advising Programs",
      type: "list",
      optionalPreface: true,
      topHTML:
        "<h4>Instructions: Description of program, role, number of learners, setting, any explanatory notes</h4>",
      items: [
        { type: "type", types: ["students"] },
        {
          name: "level",
          label: "Level",
          required: true,
          type: "select",
          options: [
            "Not selected",
            "JHMI",
            "Regional",
            "National",
            "International"
          ]
        },
        {
          name: "description",
          label: "Description of Program",
          required: true
        },
        { name: "curriculum", label: "Curriculum", required: true },
        { name: "secondary", label: "Curricular Product", required: true },
        { name: "effort", label: "Number of Learners", required: true },
        { name: "location", label: "Setting", required: true },
        { name: "comments", label: "Additional Notes (Optional)" }
      ]
    },
    {
      section: "mentoringAndCoaching",
      field: "teachingAndEducationInnovations",
      title: "Educational Programs",
      type: "list",
      optionalPreface: true,
      topHTML: function (contextState) {
        if (contextState.focusType == "assessment")
          return "<h4>Instructions: Description of Assessment and/or Evaluation program or tool; number of learners, setting; any explanatory notes</h4>";
        if (contextState.focusType == "curriculum")
          return "<h4>Instructions: Description of educational program, curriculum, curricular product; number of learners; settings; any explanatory notes</h4>";
        if (contextState.focusType == "leadership")
          return "<h4>Instructions: Role, name of educational organization, committee, program or curriculum, any explanatory notes</h4>";
        return "";
      },
      items: [
        {
          type: "type",
          types: [
            ["assessment", "Assessment and Evaluation"],
            ["curriculum", "Program Building and Curriculum Development"],
            ["leadership", "Educational Leadership"]
          ]
        },
        {
          name: "level",
          label: "Level",
          required: true,
          type: "select",
          options: [
            "Not selected",
            "JHMI",
            "Regional",
            "National",
            "International"
          ]
        },
        {
          name: "role",
          label: "Role",
          required: true,
          filter: (n) => n.type == "leadership"
        },
        {
          name: "description",
          label: "Description",
          required: true,
          filter: (n) => n.type != "leadership",
          tip: "Description of educational program, curriculum, curricular product"
        },
        {
          name: "numLearners",
          label: "Number of Learners",
          required: true,
          filter: (n) => n.type != "leadership"
        },
        {
          name: "location",
          required: true,
          label: function (item) {
            if (item.type == "leadership")
              return "Name of Educational Organization";
            return "Setting";
          }
        },
        {
          name: "committee",
          label: "Committee",
          required: true,
          filter: (n) => n.type == "leadership"
        },
        {
          name: "curriculum",
          label: "Program or Curriculum",
          filter: (n) => n.type == "leadership"
        },
        { name: "comments", label: "Additional Notes (Optional" }
      ]
    },
    {
      section: "externalDemonstration",
      field: "teachingAndEducationInnovations",
      title: "External Demonstration Activities",
      type: "list",
      optionalPreface: true,
      items: [
        { type: "type", types: ["external"] },
        {
          name: "title",
          label: "Educational Technique or Program",
          required: true
        },
        { name: "description", label: "Observing Party", required: true },
        { name: "location", label: "Venue", required: true },
        { name: "comments", label: "Additional Notes (Optional)" }
      ]
    },
    {
      section: "researchFocus",
      field: "researchInterests",
      title: "Research Focus",
      type: "obj",
      items: [
        {
          name: "current",
          label:
            "Provide up to 100 word narrative, bulleted accomplishments, or key words that express your research focus; or include NIH Biosketch section A here",
          noHide: true,
          allowFormatting: true,
          height: 600
        }
      ]
    },
    {
      field: "technologyAndScienceInnovations",
      title: "Research Activities",
      type: "list",
      optionalPreface: true,
      topHTML: function (contextState) {
        if (contextState.focusType == "invention")
          return "<h4>Instructions: Date Filed, Role, title, date awarded, note date awarded or pending; any explanatory notes</h4>";
        if (contextState.focusType == "license")
          return "<h4>Instructions: e.g. Company Start-ups; Instructions: Role, title, explanatory notes</h4>";
        return "";
      },
      items: [
        {
          type: "type",
          types: [
            ["leadership", "Research Program Building / Leadership"],
            ["activities", "Research Demonstration Activities"],
            ["invention", "Inventions, Patents, Copyrights"],
            ["license", "Technology Transfer Activities"]
          ]
        },
        {
          name: "role",
          label: "Role",
          required: true,
          filter: (n) => n.type != "activities"
        },
        {
          name: "title",
          required: true,
          shortLabel: function (item) {
            if (item.type == "leadership") return "Name of Research";
            if (item.type == "activities") return "Research Technique";
            return "Title";
          },
          label: function (item) {
            if (item.type == "leadership")
              return "Name of Research / Basic Science Program";
            if (item.type == "activities") return "Research Technique";
            return "Title";
          }
        },
        {
          name: "source",
          label: "Date Awarded or Pending",
          filter: (n) => n.type == "invention"
        },
        {
          name: "comments",
          label: "Additional Notes (Optional)",
          filter: (n) => n.type != "activities"
        },
        {
          name: "comments",
          label: "Observing Party",
          required: true,
          filter: (n) => n.type == "activities"
        },
        {
          name: "location",
          label: "Venue",
          required: true,
          filter: (n) => n.type == "activities"
        }
      ]
    },
    {
      section: "systemInnovationFocus",
      field: "researchInterests",
      title: "System Innovation Focus",
      type: "obj",
      allowFormatting: true,
      items: [
        {
          name: "quality",
          label:
            "Provide up to 100 word narrative, bulleted accomplishments, or key words that express your research focus; or include NIH Biosketch section A here",
          noHide: true,
          allowFormatting: true,
          height: 600
        }
      ]
    },
    {
      section: "systemInnovationActivities",
      field: "clinicalActivityAndInnovations",
      title: "System Innovation & Quality Improvement Activities",
      type: "list",
      optionalPreface: true,
      topHTML: function (contextState) {
        if (contextState.focusType == "internal")
          return "<h4>Instructions: Role, name of site intervention, venue (s), and results (e.g., clinical outcomes, process measures, financial)</h4>";
        return "";
      },
      items: [
        {
          type: "type",
          types: [
            ["internal", "Efforts within JHMI"],
            ["external", " Efforts outside of JHMI"],
            ["QIleadership", "Program Building / Leadership"]
          ]
        },
        { name: "role", label: "Role", required: true },
        {
          name: "title",
          required: true,
          label: function (item) {
            if (item.type == "QIleadership") return "Title of Project";
            return "Name of Site Intervention";
          }
        },
        {
          name: "location",
          label: "Location",
          required: function (item) {
            if (item.type == "QIleadership") return false;
            return true;
          }
        },
        {
          name: "results",
          label: "Results/Outcome",
          required: function (item) {
            if (item.type == "QIleadership") return false;
            return true;
          }
        },
        { name: "comments", label: "Additional Notes (Optional)" }
      ]
    },
    {
      field: "adminService",
      title: "Institutional Administrative Appointments",
      type: "list",
      optionalPreface: true,
      items: [
        { name: "title", label: "Role", required: true },
        { name: "location", label: "Committees", required: true },
        { name: "comments", label: "Additional Notes (Optional)" }
      ]
    },
    {
      field: "editorialActivities",
      title: "Editorial Activities",
      type: "list",
      optionalPreface: true,
      topHTML: function (contextState) {
        if (contextState.focusType == "board")
          return "<h4>Instructions: Role, Editorial Board/Journal name</h4>";
        if (contextState.focusType == "Ad hoc Reviewer")
          return "<h4>Instructions: Non-medico-legal</h4>";
        return "";
      },
      items: [
        {
          type: "type",
          types: [
            ["board", "Editorial Board Appointments"],
            ["Other Editorial Roles", "Journal Peer Review Activities"],
            ["Ad hoc Reviewer", "Other Peer Review Activities"]
          ]
        },
        {
          name: "role",
          label: "Role",
          required: true,
          filter: (n) => n.type != "Other Editorial Roles"
        },
        {
          name: "journal",
          required: true,
          tip: "Do not abbreviate here.",
          label: "Journal Name"
        },
        { name: "comments", label: "Additional Notes (Optional)" }
      ]
    },
    {
      field: "grantReviewActivities",
      title: "Advisory Committees, Review Groups/Study Sections",
      type: "list",
      optionalPreface: true,
      topHTML:
        "<h4>Instructions: Role, sponsor/organization/group, explanatory notes</h4>",
      items: [
        { name: "role", label: "Role", required: true },
        {
          name: "committee",
          label: "Sponsor/Organization/Group",
          required: true
        },
        { name: "comments", label: "Additional Notes (Optional)" }
      ]
    },
    {
      field: "societies",
      title: "Professional Societies",
      type: "list",
      optionalPreface: true,
      items: [
        { name: "society", label: "Society Name", required: true },
        { name: "comments", label: "Additional Notes (Optional)" },
        {
          type: "list",
          name: "roles",
          noAdvancedImport: true,
          label: "Roles",
          sublist: { name: "role", label: "Title of Role, Committee" }
        }
      ]
    },
    {
      section: "conference",
      field: "meetingActivities",
      title: "Conference Organizer",
      type: "list",
      optionalPreface: true,
      topHTML:
        "<h4>Instructions: Sponsor/organization/group, explanatory notes</h4>",
      items: [
        { type: "type", types: ["conference"] },
        {
          name: "level",
          label: "Level",
          required: true,
          type: "select",
          options: [
            "Not Selected",
            "JHMI",
            "Regional",
            "National",
            "International"
          ]
        },
        {
          name: "location",
          label: "Sponsor/Organization/Group",
          required: true
        },
        { name: "comments", label: "Additional Notes (Optional)" }
      ]
    },
    {
      section: "session",
      field: "meetingActivities",
      title: "Session Chair",
      type: "list",
      optionalPreface: true,
      topHTML:
        "<h4>Instructions: Sponsor/organization/group, explanatory notes</h4>",
      items: [
        { type: "type", types: ["session"] },
        {
          name: "level",
          label: "Level",
          required: true,
          type: "select",
          options: [
            "Not selected",
            "JHMI",
            "Regional",
            "National",
            "International"
          ]
        },
        {
          name: "location",
          label: "Sponsor/Organization/Group",
          required: true
        },
        { name: "comments", label: "Additional Notes (Optional)" }
      ]
    },
    {
      field: "otherPositions",
      title: "Consultantships",
      type: "list",
      optionalPreface: true,
      topHTML: "<h4>Instructions: Organization/agency, explanatory notes</h4>",
      items: [
        { type: "type", types: ["professional"] },
        { name: "location", label: "Organization/Agency", required: true },
        { name: "comments", label: "Additional Notes (Optional)" }
      ]
    },
    {
      field: "honors",
      title: "Awards/Honors",
      type: "list",
      optionalPreface: true,
      topHTML:
        "<h4>Instructions: Title, description, sponsor, any explanatory notes</h4>",
      items: [
        { name: "title", label: "Title", required: true },
        { name: "description", label: "Description", required: true },
        { name: "location", label: "Sponsor", required: true },
        { name: "comments", label: "Additional Notes (Optional)" }
      ]
    },
    {
      field: "presentations",
      title: "Invited Talks, Professorships, Posters, and Presentations",
      type: "list",
      noBullets: true,
      optionalPreface: true,
      topHTML: function (contextState) {
        if (contextState.focusTabKey == "oral")
          return "<h4>Instructions: Optional; Abstracts that were both presented orally and published</h4>";
        if (contextState.focusTabKey == "posters")
          return "<h4>Instructions: Optional</h4>";
        if (contextState.focusTabKey == "other")
          return "<h4>Instructions: Optional; Anything that does not fit into other categories</h4>";
        return "";
      },
      items: [
        {
          type: "customTab",
          tabs: [
            {
              key: "talksLocal",
              name: "Invited Talks (JHMI)",
              defaultData: {
                type: "local",
                presType: "Invited Lecture",
                invitedProfessorship: false
              },
              filter: function (item) {
                return (
                  item.type == "local" &&
                  ["invited", "grand rounds"].some(
                    (n) => (item.presType || "").toLowerCase().indexOf(n) >= 0
                  ) &&
                  !item.invitedProfessorship
                );
              }
            },
            {
              key: "talksRegional",
              name: "Invited Talks (Regional)",
              defaultData: {
                type: "regional",
                presType: "Invited Lecture",
                invitedProfessorship: false
              },
              filter: function (item) {
                return (
                  item.type == "regional" &&
                  ["invited", "grand rounds"].some(
                    (n) => (item.presType || "").toLowerCase().indexOf(n) >= 0
                  ) &&
                  !item.invitedProfessorship
                );
              }
            },
            {
              key: "talksNational",
              name: "Invited Talks (National)",
              defaultData: {
                type: "national",
                presType: "Invited Lecture",
                invitedProfessorship: false
              },
              filter: function (item) {
                return (
                  item.type == "national" &&
                  ["invited", "grand rounds"].some(
                    (n) => (item.presType || "").toLowerCase().indexOf(n) >= 0
                  ) &&
                  !item.invitedProfessorship
                );
              }
            },
            {
              key: "talksInternational",
              name: "Invited Talks (International)",
              defaultData: {
                type: "international",
                presType: "Invited Lecture",
                invitedProfessorship: false
              },
              filter: function (item) {
                return (
                  item.type == "international" &&
                  ["invited", "grand rounds"].some(
                    (n) => (item.presType || "").toLowerCase().indexOf(n) >= 0
                  ) &&
                  !item.invitedProfessorship
                );
              }
            },
            {
              key: "visitingProf",
              name: "Visiting Professorships",
              defaultData: { invitedProfessorship: true },
              filter: function (item) {
                return !!item.invitedProfessorship;
              }
            },
            {
              key: "posters",
              name: "Posters",
              defaultData: { presType: "Poster", invitedProfessorship: false },
              filter: function (item) {
                return (
                  item.presType == "Poster" &&
                  !item.invitedProfessorship &&
                  !["invited", "grand rounds"].some(
                    (n) => (item.presType || "").toLowerCase().indexOf(n) >= 0
                  )
                );
              }
            },
            {
              key: "oral",
              name: "Oral / Podium Presentations",
              defaultData: { presType: "Podium", invitedProfessorship: false },
              filter: function (item) {
                return (
                  ["platform", "podium", "oral", "talk"].some(
                    (n) => (item.presType || "").toLowerCase().indexOf(n) >= 0
                  ) &&
                  !item.invitedProfessorship &&
                  !["invited", "grand rounds"].some(
                    (n) => (item.presType || "").toLowerCase().indexOf(n) >= 0
                  )
                );
              }
            }
          ]
        },
        {
          type: "select",
          name: "presType",
          label: "Type of Instruction",
          height: 130,
          noAdvancedImport: true,
          allowOther: true,
          options: [
            "Not Selected",
            "Grand Rounds",
            "Invited Lecture",
            "Talk",
            "Platform",
            "Podium",
            "Poster",
            "Paper",
            "Workshop"
          ]
        },
        {
          name: "title",
          label: "Title",
          required: true
        },
        { name: "location", label: "Venue", required: true },
        {
          name: "sponsor",
          label: "Sponsor"
        },

        { name: "comments", label: "Additional Notes (Optional)" },
        {
          name: "invitedProfessorship",
          type: "checkbox",
          label: "Visiting Professorship"
        }
      ]
    },
    {
      field: "military",
      title: "Military Service",
      type: "list",
      optionalPreface: true,
      topHTML: "<h4>Instructions: Optional</h4>",
      items: [
        { name: "title", label: "Rank", required: true },
        { name: "comments", label: "Additional Notes (Optional)" }
      ]
    },
    {
      field: "community",
      title: "Community Service and Humanitarian Activities",
      type: "list",
      optionalPreface: true,
      topHTML: "<h4>Instructions: Optional</h4>",
      items: [
        {
          type: "type",
          types: [
            ["Activities", "Community Service"],
            ["humanitarian", "Humanitarian Activities"],
            ["philanthropy", "Philanthropic Activities"]
          ]
        },
        { name: "title", label: "Name of Activity", required: true },
        { name: "description", label: "Description", required: true },
        { name: "location", label: "Location (Optional)" },
        { name: "comments", label: "Additional Notes (Optional)" }
      ]
    },
    {
      field: "stanfordMore",
      title: "Other Activities",
      type: "list",
      optionalPreface: true,
      topHTML: "<h4>Instructions: Optional</h4>",
      items: [
        { name: "title", label: "Name of Activity", required: true },
        { name: "description", label: "Description" },
        { name: "comments", label: "Additional Notes (Optional)" }
      ]
    },
    getAcgmeTemplateSection(serverACGMEResult),
    // getCareerSection({ reviewReport: true }),
    getBiosketchSection({
      sections: {
        positions: {
          facultyAppointments: serialize(["title", "location"]),
          hospitalAppointments: serialize(["title", "location"]),
          otherPositions: serialize(["title", "location"]),
          administrativePositions: serialize(["title", "location"]),
          committeeService: serialize(["role", "title"]),
          societies: serialize(["role", "society"])
        },
        honors: {
          // honors section
          honors: serialize(["title", "location"])
        },
        sciContribution: {
          // pull publications
          scholarship: serialize(["line"]),
          projects: serialize(
            [
              "projectFocus",
              "grantTypeAndNumber",
              function (item) {
                return (
                  (item.piName == null ? "" : item.piName + " (PI), ") +
                  "Role: " +
                  item.role
                );
              },
              "title"
            ],
            "<br>"
          ),
          technologyAndScienceInnovations: serialize(["role", "title"]),
          systemInnovationActivities: serialize(["role", "title"])
        },
        addInfo: {
          // publications and projects
          scholarship: serialize(["line"]),
          projects: serialize(
            [
              "projectFocus",
              "grantTypeAndNumber",
              function (item) {
                return (
                  (item.piName == null ? "" : item.piName + " (PI), ") +
                  "Role: " +
                  item.role
                );
              },
              "title"
            ],
            "<br>"
          ),
          technologyAndScienceInnovations: serialize(["role", "title"]),
          systemInnovationActivities: serialize(["role", "title"])
        }
      }
    })
  ],
  // Preview
  preview: [
    '<h4 style="text-align: center;">Curriculum Vitae</h4>',
    '<h4 style="text-align: center;">The Johns Hopkins University School of Medicine</h4>',
    "<br>",
    function (def) {
      return def.genDate == null
        ? null
        : '<h4 style="text-align: center;">' +
            escapeHtml(def.bio_name || "") +
            "&emsp;&emsp;&emsp;&emsp;" +
            escapeHtml(def.genDate || "") +
            "</h4><br>";
    },
    "<br>",
    '<h4 style="text-align: left;"><b>DEMOGRAPHIC AND PERSONAL INFORMATION</b></h4>',
    '<h4 style="text-align: left;">Current Appointments</h4>',
    previewSection("caua", "University", ["t", "1"]),
    previewSection("caha", "Hospital", ["t", "1"]),
    previewSection("caoa", "Other", ["t", "1"]),
    "<br>",
    "<h4>Personal Data</h4>",
    function (def) {
      return def.bio_division == null
        ? null
        : "&emsp;&emsp;&emsp;&emsp;" +
            escapeHtml(def.bio_division || "") +
            "<br>";
    },
    function (def) {
      return def.bio_department == null
        ? null
        : "&emsp;&emsp;&emsp;&emsp;" +
            escapeHtml(def.bio_department || "") +
            "<br>";
    },
    function (def) {
      return def.bio_officeAddress == null
        ? null
        : "&emsp;&emsp;&emsp;&emsp;" +
            escapeHtml(def.bio_officeAddress || "") +
            "<br>";
    },
    function (def) {
      return def.bio_officeLocation == null
        ? null
        : "&emsp;&emsp;&emsp;&emsp;" +
            escapeHtml(def.bio_officeLocation || "") +
            "<br>";
    },
    function (def) {
      return def.bio_workPhone == null
        ? null
        : "&emsp;&emsp;&emsp;&emsp;Tel&emsp;" +
            escapeHtml(def.bio_workPhone || "") +
            "<br>";
    },
    function (def) {
      return def.bio_workFax == null
        ? null
        : "&emsp;&emsp;&emsp;&emspFax&emsp;;" +
            escapeHtml(def.bio_workFax || "") +
            "<br>";
    },
    function (def) {
      return def.bio_workEmail == null
        ? null
        : "&emsp;&emsp;&emsp;&emsp;E-Mail&emsp;" +
            escapeHtml(def.bio_workEmail || "") +
            "<br>";
    },
    "<br>",
    '<h4">Education and Training</h4>',
    function (def) {
      return def.eduPre == null
        ? null
        : "<p>" + escapeHtml(def.eduPre || "") + "</p>";
    },
    previewSections("eduSections", ["t", "1"]),
    "<p>Postdoctoral</p>",
    function (def) {
      return def.pdtPre == null
        ? null
        : "<p>" + escapeHtml(def.pdtPre || "") + "</p>";
    },
    previewSections("pdtSections", ["t", "1"]),
    "<br>",
    previewSection("pe", '<h4">Professional Experience</h4>', ["t", "1"]),
    "<br>",
    "<h4><b>PUBLICATIONS</b></h4>",
    function (def) {
      return def.schPre == null
        ? null
        : "<p>" + escapeHtml(def.schPre || "") + "</p>";
    },
    previewSections("schSections", ["1", "2"]),
    "<br>",
    "<h4>Other Publications:</h4>",
    function (def) {
      return def.oschPre == null
        ? null
        : "<p>" + escapeHtml(def.oschPre || "") + "</p>";
    },
    previewSections("oschSections", ["1", "2"]),
    "<br>",
    "<h4><b>FUNDING</b></h4>",
    "<h4>EXTRAMURAL Funding</h4>",
    "<p>Research Extramural Funding</p>",
    previewSections("frextSections", ["t", "1"]),
    "<p>Educational Extramural Funding</p>",
    previewSections("feextSections", ["t", "1"]),
    "<p>Clinical Extramural Funding</p>",
    previewSections("fcextSections", ["t", "1"]),
    "<p>System Innovation or Quality Improvement Extramural Funding</p>",
    previewSections("fsiextSections", ["t", "1"]),
    "<p>Other Extramural Funding</p>",
    previewSections("foextSections", ["t", "1"]),
    "<h4>INTRAMURAL Funding</h4>",
    "<p>Research Intramural Funding</p>",
    previewSections("frintSections", ["t", "1"]),
    "<p>Educational Intramural Funding</p>",
    previewSections("feintSections", ["t", "1"]),
    "<p>Clinical Intramural Funding</p>",
    previewSections("fcintSections", ["t", "1"]),
    "<p>System Innovation or Quality Improvement Intramural Funding</p>",
    previewSections("fsiintSections", ["t", "1"]),
    "<p>Other Intramural Funding</p>",
    previewSections("fointSections", ["t", "1"]),
    "<h4><b>CLINICAL ACTIVITIES</b></h4>",
    function (def) {
      return def.ca_clinicalFocus == null
        ? null
        : "<h4>Clinical Focus</h4><p>" +
            escapeHtml(def.ca_clinicalFocus || "", { allowTags: true }) +
            "</p><br>";
    },
    "<h4>Certification</h4>",
    previewSections("certSections", ["t", "1"]),
    "<br>",
    previewSection("cser", "Clinical (Service) Responsibilities", ["t", "1"]),
    "<br>",
    function (def) {
      return def.ca_clinicalProductivity == null
        ? null
        : "<h4>Clinical Productivity</h4><p>" +
            escapeHtml(def.ca_clinicalProductivity || "", { allowTags: true }) +
            "</p><br>";
    },
    previewSections("clacSections", ["t", "1"]),
    previewSection(
      "dcsc",
      "Development of nationally/internationally recognized clinical standard of care",
      ["t", "1"]
    ),
    "<br>",
    "<h4><b>EDUCATIONAL ACTIVITIES</b></h4>",
    function (def) {
      return def.ed_educationalFocus == null
        ? null
        : "<h4>Educational Focus</h4><p>" +
            escapeHtml(def.ed_educationalFocus || "", { allowTags: true }) +
            "</p><br>";
    },
    "<h4>Teaching and Facilitating Learning</h4>",
    "<p>Classroom instruction</p>",
    previewSections("tch1Sections", ["t", "1"]),
    "<p>Clinical instruction</p>",
    previewSections("tch2Sections", ["t", "1"]),
    "<p>CME Instruction</p>",
    previewSections("tch3Sections", ["t", "1"]),
    "<p>Workshops / seminars</p>",
    previewSections("tch3Sections", ["t", "1"]),
    "<br>",
    "<h4>Mentoring, coaching, and advising</h4>",
    function (def) {
      return def.mentPre == null
        ? null
        : "<p>" + escapeHtml(def.mentPre || "") + "</p>";
    },
    previewSections("mentSections", ["t", "1"]),
    "<br>",
    "<p>Mentoring, coaching, and advising programs</p>",
    function (def) {
      return def.ment2Pre == null
        ? null
        : "<p>" + escapeHtml(def.ment2Pre || "") + "</p>";
    },
    previewSections("ment2Sections", ["t", "1"]),
    "<br>",
    "<h4>Assessment and Evaluation</h4>",
    previewSections("eda1Sections", ["t", "1"]),
    "<br>",
    "<h4>Program Building and Curriculum Development</h4>",
    previewSections("eda2Sections", ["t", "1"]),
    "<br>",
    "<h4>Educational Leadership</h4>",
    previewSections("eda3Sections", ["t", "1"]),
    "<br>",
    previewSection(
      "edda",
      "<h4>Educational Demonstration Activities to external audiences</h4>",
      ["t", "1"]
    ),
    "<h4><b>RESEARCH ACTIVITIES</b></h4>",
    function (def) {
      return def.ra_researchFocus == null
        ? null
        : "<p>Research Focus</p><p>" +
            escapeHtml(def.ra_researchFocus || "", { allowTags: true }) +
            "</p><br>";
    },
    previewSections("raSections", ["t", "1"]),
    "<br>",
    "<h4><b>SYSTEM INNOVATION AND QUALITY IMPROVEMENT ACTIVITIES</b></h4>",
    function (def) {
      return def.si_systemInnovationFocus == null
        ? null
        : "<p>System Innovation Focus</p><p>" +
            escapeHtml(def.si_systemInnovationFocus || "", {
              allowTags: true
            }) +
            "</p><br>";
    },
    previewSections("siqiSections", ["t", "1"]),
    "<h4><b>ORGANIZATIONAL ACTIVITIES</b></h4>",
    previewSection("iaa", "International Administrative Appointments", [
      "t",
      "1"
    ]),
    "<br>",
    "<h4>Editorial Activities</h4>",
    previewSections("eaSections", ["t", "1"]),
    previewSection(
      "oaac",
      "Advisory Committees, Review Groups/Study Sections",
      ["t", "1"]
    ),
    previewSection("oaps", "Professional Societies", ["t", "1", "2"]),
    "<p>Conference Organizer</p>",
    previewSections("coSections", ["t", "1"]),
    "<p>Session Chair</p>",
    previewSections("scSections", ["t", "1"]),
    previewSection("cs", "Consultantships", ["t", "1"]),
    "<br>",
    "<h4><b>RECOGNITION</b></h4>",
    previewSection("ah", "Awards, Honors", ["t", "1"]),
    "<br>",
    "<p>Invited Talks</p>",
    previewSections("itSections", ["t", "1"]),
    previewSection("vp", "Visiting Professorships", ["t", "1"]),
    "<h4><b>OTHER PROFESSIONAL ACCOMPLISHMENTS</b></h4>",
    previewSection("pst", "Posters", ["t", "1"]),
    previewSection("pod", "Oral/Podium Presentations", ["t", "1"]),
    previewSection("mil", "Military Service", ["t", "1"]),
    previewSections("chpSections", ["t", "1"]),
    previewSection("oth", "Other", ["t", "1"])
  ],
  outputSettings: { font: "Garamond", fontSize: 11, totalCount: true },
  output: {
    // Logo toggles
    non: {
      toggle: hopkinsLogoOutput("non")
    },
    med: {
      toggle: hopkinsLogoOutput("med")
    },
    nurs: {
      toggle: hopkinsLogoOutput("nurs")
    },
    bsph: {
      toggle: hopkinsLogoOutput("bsph")
    },
    // Demographic and Personal Info
    // Current Appointments
    // University Appointments
    cuapSection: {
      toggle: function (cvDef, filter, { customExportSettings }) {
        var emptySections =
          typeof customExportSettings != "undefined" &&
          customExportSettings.emptySections != null &&
          !!customExportSettings.emptySections;
        return (
          emptySections ||
          getField(cvDef, "facultyAppointments")
            .filter(filter)
            .filter((n) => n.time?.end == "ongoing")
            .concat(
              getField(cvDef, "hospitalAppointments")
                .filter(filter)
                .filter((n) => n.time?.end == "ongoing")
            )
            .concat(
              getField(cvDef, "otherPositions")
                .filter(filter)
                .filter((n) => n.time?.end == "ongoing")
            ).length > 0
        );
      }
    },
    caua: {
      field: "facultyAppointments",
      filter: (n) => n.time?.end == "ongoing",
      format: {
        t: ["fullMonthDayYear"],
        1: [mergeItems([{ key: "title" }, { key: "location" }])]
      }
    },
    // Hospital Appointments
    caha: {
      field: "hospitalAppointments",
      filter: (n) => n.time?.end == "ongoing",
      format: {
        t: ["fullMonthDayYear"],
        1: [mergeItems([{ key: "title" }, { key: "location" }])]
      }
    },
    // Other Appointments
    caoa: {
      field: "otherPositions",
      type: "academic",
      section: "otherAppointments",
      filter: (n) => n.time?.end == "ongoing",
      format: {
        t: ["fullMonthDayYear"],
        1: [mergeItems([{ key: "title" }, { key: "location" }])]
      }
    },
    // Personal Data
    bio: {
      field: "bio",
      map: {
        bio_name: "name",
        bio_officeAddress: "officeAddress",
        bio_division: "division",
        bio_department: "dept",
        bio_officeLocation: "officeLocation",
        bio_workPhone: "workPhone",
        bio_workFax: "workFax",
        bio_workEmail: "workEmail"
      }
    },
    // Education and training
    edu: {
      field: "education",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems([
            { key: "degree" },
            { key: "secondaryInfo" },
            { key: "location" }
          ]),
          "notes"
        ]
      },
      sections: [
        { type: "undergraduate", title: "Undergraduate " },
        { type: "graduate", title: "Doctoral/graduate" }
      ]
    },
    pdt: {
      field: "postDoctoralTraining",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems([
            { key: "degree" },
            { key: "field" },
            { key: "location" }
          ]),
          "notes"
        ]
      },
      sections: [
        { type: "internship", title: "Internship" },
        { type: "residency", title: "Residency" },
        { type: "fellowship", title: "Fellowship" },
        { type: "other", title: "Other" }
      ]
    },
    // Professional Experience
    // University Appointments
    prexSection: {
      toggle: function (cvDef, filter, { customExportSettings }) {
        var emptySections =
          typeof customExportSettings != "undefined" &&
          customExportSettings.emptySections != null &&
          !!customExportSettings.emptySections;
        return (
          emptySections ||
          getField(cvDef, "facultyAppointments")
            .filter(filter)
            .concat(getField(cvDef, "hospitalAppointments").filter(filter))
            .concat(getField(cvDef, "otherPositions").filter(filter))
            .filter((n) => n.time?.end != "ongoing").length > 0
        );
      }
    },
    pe: {
      field: "facultyAppointments",
      format: {
        t: ["fullMonthDayYear"],
        1: [mergeItems([{ key: "title" }, { key: "location" }]), "comments"]
      },
      data: function (def, details, opts) {
        let list = sortField(
          getField(def, "facultyAppointments", { addId: true })
            .concat(getField(def, "hospitalAppointments", { addId: true }))
            .concat(
              getField(def, "otherPositions", { addId: true }).filter(
                (n) => n.type != "professional"
              )
            ),
          { sectionFormat: details.format }
        );
        return list;
      }
    },
    // Publications
    sch: {
      field: "scholarship",
      preface: true,
      format: {
        1: getIndex,
        2: function (item, i, cvDef, genOpts = {}) {
          return [
            getCitation("line")(item, i, cvDef, genOpts),
            getFormatted("comments", { indent: 600 })(item, i, cvDef, genOpts)
          ].join(genOpts.noXML ? "<br>" : "");
        }
      },
      sectionsArray: [
        { type: "Research Investigations", title: "Original Research [OR]" },
        { type: "reviews", title: "Review Articles [RA]" },
        { type: "Case reports", title: "Case Reports [CR]" },
        { type: "chapters", title: "Book Chapters, Monographs [BC]" },
        {
          type: "Books/textbooks for the medical or scientific community",
          title: "Books, Textbooks [BK]"
        },
        { type: "editorials", title: "Editorials [ED]" },
        {
          type: "Clinical Guidelines and Reports",
          title:
            "Guidelines/Protocols, Consensus Statement, Expert Opinion, Consortium Articles [GL] "
        },
        { type: "Letters to the Editor", title: "Letters, Correspondence [LT]" }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Other Publications
    osch: {
      field: "scholarship",
      preface: true,
      format: {
        1: getIndex,
        2: function (item, i, cvDef, genOpts = {}) {
          return [
            getCitation("line")(item, i, cvDef, genOpts),
            getFormatted("comments", { indent: 600 })(item, i, cvDef, genOpts)
          ].join(genOpts.noXML ? "<br>" : "");
        }
      },
      sectionsArray: [
        { type: "memoirs", title: "Clinical Stories or Memoirs [CS]" },
        { type: "creativeWriting", title: "Creative Writing [CW]" },
        {
          type: "methods",
          title: "Methods and Techniques, “How I Do It” articles [MT]"
        },
        {
          type: "commentaries",
          title:
            "Opinions, Perspectives, Political Commentary, Advocacy, Essays [OP]"
        },
        {
          type: "Proceedings of meetings or other non-peer reviewed scholarship",
          title:
            "Original Research, other (not peer reviewed and/or not indexed) [RO]"
        },
        { type: "proceedingsReports", title: "Proceedings Reports [PR]" },
        {
          type: "Professional educational materials or reports, in print or other media",
          title:
            "Published Curricula, Learner Assessment Tools, Educational Evaluations, Assessment/Evaluation Instruments [PC]"
        },
        { type: "policy", title: "White Papers [WP]" },
        { type: "interviews", title: "Media Releases or Interviews [MR]" },
        {
          type: "media",
          title:
            "Other Media [OM] (Videos, Websites, Blogs, Social Media, etc.)"
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Funding
    fund: { field: "projects", type: "funded", preface: true },
    // Extramural
    fundextSection: {
      toggle: function (cvDef, filter, { customExportSettings }) {
        var emptySections =
          typeof customExportSettings != "undefined" &&
          customExportSettings.emptySections != null &&
          !!customExportSettings.emptySections;
        return (
          emptySections ||
          getField(cvDef, "projects")
            .filter(filter)
            .filter((n) => n.sourceType == "Extramural").length > 0
        );
      }
    },
    // Research Extramural
    frext: {
      field: "projects",
      format: {
        t: ["fullMonthDayYear"],
        1: function (item, i, cvDef, genOpts = {}) {
          return [
            getText(item, "title"),
            getText(item, "grantTypeAndNumber"),
            getText(item, "fundingSource"),
            getText(item, "directCosts"),
            getText(item, "piName"),
            mergeItems([
              { key: "role" },
              { key: "workTime" },
              { key: "description" }
            ])(item, i, cvDef, genOpts)
          ]
            .filter((n) => n != "")
            .join(genOpts.noXML ? "<br>" : "\n");
        }
      },
      sectionsArray: [
        {
          title: "Current",
          filter: (n) =>
            n.projectFocus == "Research" &&
            n.sourceType == "Extramural" &&
            !n.pending &&
            isTodayWithinRange(n.time)
        },
        {
          title: "Pending",
          filter: (n) =>
            n.projectFocus == "Research" &&
            n.sourceType == "Extramural" &&
            !!n.pending
        },
        {
          title: "Previous",
          filter: (n) =>
            n.projectFocus == "Research" &&
            n.sourceType == "Extramural" &&
            !isTodayWithinRange(n.time) &&
            !n.pending
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Educational Extramural
    feext: {
      field: "projects",
      format: {
        t: ["fullMonthDayYear"],
        1: function (item, i, cvDef, genOpts = {}) {
          return [
            getText(item, "title"),
            getText(item, "grantTypeAndNumber"),
            getText(item, "fundingSource"),
            getText(item, "directCosts"),
            getText(item, "piName"),
            mergeItems([
              { key: "role" },
              { key: "workTime" },
              { key: "description" }
            ])(item, i, cvDef, genOpts)
          ]
            .filter((n) => n != "")
            .join(genOpts.noXML ? "<br>" : "\n");
        }
      },
      sectionsArray: [
        {
          title: "Current",
          filter: (n) =>
            n.projectFocus == "Educational" &&
            n.sourceType == "Extramural" &&
            isTodayWithinRange(n.time)
        },
        {
          title: "Pending",
          filter: (n) =>
            n.projectFocus == "Educational" &&
            n.sourceType == "Extramural" &&
            !!n.pending
        },
        {
          title: "Previous",
          filter: (n) =>
            n.projectFocus == "Educational" &&
            n.sourceType == "Extramural" &&
            !isTodayWithinRange(n.time) &&
            !n.pending
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Clinical Extramural
    fcext: {
      field: "projects",
      format: {
        t: ["fullMonthDayYear"],
        1: function (item, i, cvDef, genOpts = {}) {
          return [
            getText(item, "title"),
            getText(item, "grantTypeAndNumber"),
            getText(item, "fundingSource"),
            getText(item, "directCosts"),
            getText(item, "piName"),
            mergeItems([
              { key: "role" },
              { key: "workTime" },
              { key: "description" }
            ])(item, i, cvDef, genOpts)
          ]
            .filter((n) => n != "")
            .join(genOpts.noXML ? "<br>" : "\n");
        }
      },
      sectionsArray: [
        {
          title: "Current",
          filter: (n) =>
            n.projectFocus == "Clinical" &&
            n.sourceType == "Extramural" &&
            isTodayWithinRange(n.time)
        },
        {
          title: "Pending",
          filter: (n) =>
            n.projectFocus == "Clinical" &&
            n.sourceType == "Extramural" &&
            !!n.pending
        },
        {
          title: "Previous",
          filter: (n) =>
            n.projectFocus == "Clinical" &&
            n.sourceType == "Extramural" &&
            !isTodayWithinRange(n.time) &&
            !n.pending
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // System Innovation or Quality Improvement Extramural
    fsiext: {
      field: "projects",
      format: {
        t: ["fullMonthDayYear"],
        1: function (item, i, cvDef, genOpts = {}) {
          return [
            getText(item, "title"),
            getText(item, "grantTypeAndNumber"),
            getText(item, "fundingSource"),
            getText(item, "directCosts"),
            getText(item, "piName"),
            mergeItems([
              { key: "role" },
              { key: "workTime" },
              { key: "description" }
            ])(item, i, cvDef, genOpts)
          ]
            .filter((n) => n != "")
            .join(genOpts.noXML ? "<br>" : "\n");
        }
      },
      sectionsArray: [
        {
          title: "Current",
          filter: (n) =>
            n.projectFocus == "System Innovation or Quality Improvement" &&
            n.sourceType == "Extramural" &&
            isTodayWithinRange(n.time)
        },
        {
          title: "Pending",
          filter: (n) =>
            n.projectFocus == "System Innovation or Quality Improvement" &&
            n.sourceType == "Extramural" &&
            !!n.pending
        },
        {
          title: "Previous",
          filter: (n) =>
            n.projectFocus == "System Innovation or Quality Improvement" &&
            n.sourceType == "Extramural" &&
            !isTodayWithinRange(n.time) &&
            !n.pending
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Other Extramural
    foext: {
      field: "projects",
      format: {
        t: ["fullMonthDayYear"],
        1: function (item, i, cvDef, genOpts = {}) {
          return [
            getText(item, "title"),
            getText(item, "grantTypeAndNumber"),
            getText(item, "fundingSource"),
            getText(item, "directCosts"),
            getText(item, "piName"),
            mergeItems([
              { key: "role" },
              { key: "workTime" },
              { key: "description" }
            ])(item, i, cvDef, genOpts)
          ]
            .filter((n) => n != "")
            .join(genOpts.noXML ? "<br>" : "\n");
        }
      },
      sectionsArray: [
        {
          title: "Current",
          filter: (n) =>
            n.projectFocus == "Other" &&
            n.sourceType == "Extramural" &&
            isTodayWithinRange(n.time)
        },
        {
          title: "Pending",
          filter: (n) =>
            n.projectFocus == "Other" &&
            n.sourceType == "Extramural" &&
            !!n.pending
        },
        {
          title: "Previous",
          filter: (n) =>
            n.projectFocus == "Other" &&
            n.sourceType == "Extramural" &&
            !isTodayWithinRange(n.time) &&
            !n.pending
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Intramural
    fundintSection: {
      toggle: function (cvDef, filter, { customExportSettings }) {
        var emptySections =
          typeof customExportSettings != "undefined" &&
          customExportSettings.emptySections != null &&
          !!customExportSettings.emptySections;
        return (
          emptySections ||
          getField(cvDef, "projects")
            .filter(filter)
            .filter((n) => n.sourceType == "Intramural").length > 0
        );
      }
    },
    fundExtTotal: {
      totals: [
        "frextTotal",
        "feextTotal",
        "fcextTotal",
        "fsiextTotal",
        "foextTotal"
      ]
    },
    // Research Intramural
    frint: {
      field: "projects",
      format: {
        t: ["fullMonthDayYear"],
        1: function (item, i, cvDef, genOpts = {}) {
          return [
            getText(item, "title"),
            getText(item, "grantTypeAndNumber"),
            getText(item, "fundingSource"),
            getText(item, "directCosts"),
            getText(item, "piName"),
            mergeItems([
              { key: "role" },
              { key: "workTime" },
              { key: "description" }
            ])(item, i, cvDef, genOpts)
          ]
            .filter((n) => n != "")
            .join(genOpts.noXML ? "<br>" : "\n");
        }
      },
      sectionsArray: [
        {
          title: "Current",
          filter: (n) =>
            n.projectFocus == "Research" &&
            n.sourceType == "Intramural" &&
            !n.pending &&
            isTodayWithinRange(n.time)
        },
        {
          title: "Pending",
          filter: (n) =>
            n.projectFocus == "Research" &&
            n.sourceType == "Intramural" &&
            !!n.pending
        },
        {
          title: "Previous",
          filter: (n) =>
            n.projectFocus == "Research" &&
            n.sourceType == "Intramural" &&
            !isTodayWithinRange(n.time) &&
            !n.pending
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Educational Intramural
    feint: {
      field: "projects",
      format: {
        t: ["fullMonthDayYear"],
        1: function (item, i, cvDef, genOpts = {}) {
          return [
            getText(item, "title"),
            getText(item, "grantTypeAndNumber"),
            getText(item, "fundingSource"),
            getText(item, "directCosts"),
            getText(item, "piName"),
            mergeItems([
              { key: "role" },
              { key: "workTime" },
              { key: "description" }
            ])(item, i, cvDef, genOpts)
          ]
            .filter((n) => n != "")
            .join(genOpts.noXML ? "<br>" : "\n");
        }
      },
      sectionsArray: [
        {
          title: "Current",
          filter: (n) =>
            n.projectFocus == "Educational" &&
            n.sourceType == "Intramural" &&
            isTodayWithinRange(n.time)
        },
        {
          title: "Pending",
          filter: (n) =>
            n.projectFocus == "Educational" &&
            n.sourceType == "Intramural" &&
            !!n.pending
        },
        {
          title: "Previous",
          filter: (n) =>
            n.projectFocus == "Educational" &&
            n.sourceType == "Intramural" &&
            !isTodayWithinRange(n.time) &&
            !n.pending
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Clinical Intramural
    fcint: {
      field: "projects",
      format: {
        t: ["fullMonthDayYear"],
        1: function (item, i, cvDef, genOpts = {}) {
          return [
            getText(item, "title"),
            getText(item, "grantTypeAndNumber"),
            getText(item, "fundingSource"),
            getText(item, "directCosts"),
            getText(item, "piName"),
            mergeItems([
              { key: "role" },
              { key: "workTime" },
              { key: "description" }
            ])(item, i, cvDef, genOpts)
          ]
            .filter((n) => n != "")
            .join(genOpts.noXML ? "<br>" : "\n");
        }
      },
      sectionsArray: [
        {
          title: "Current",
          filter: (n) =>
            n.projectFocus == "Clinical" &&
            n.sourceType == "Intramural" &&
            isTodayWithinRange(n.time)
        },
        {
          title: "Pending",
          filter: (n) =>
            n.projectFocus == "Clinical" &&
            n.sourceType == "Intramural" &&
            !!n.pending
        },
        {
          title: "Previous",
          filter: (n) =>
            n.projectFocus == "Clinical" &&
            n.sourceType == "Intramural" &&
            !isTodayWithinRange(n.time) &&
            !n.pending
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // System Innovation or Quality Improvement Intramural
    fsiint: {
      field: "projects",
      format: {
        t: ["fullMonthDayYear"],
        1: function (item, i, cvDef, genOpts = {}) {
          return [
            getText(item, "title"),
            getText(item, "grantTypeAndNumber"),
            getText(item, "fundingSource"),
            getText(item, "directCosts"),
            getText(item, "piName"),
            mergeItems([
              { key: "role" },
              { key: "workTime" },
              { key: "description" }
            ])(item, i, cvDef, genOpts)
          ]
            .filter((n) => n != "")
            .join(genOpts.noXML ? "<br>" : "\n");
        }
      },
      sectionsArray: [
        {
          title: "Current",
          filter: (n) =>
            n.projectFocus == "System Innovation or Quality Improvement" &&
            n.sourceType == "Intramural" &&
            isTodayWithinRange(n.time)
        },
        {
          title: "Pending",
          filter: (n) =>
            n.projectFocus == "System Innovation or Quality Improvement" &&
            n.sourceType == "Intramural" &&
            !!n.pending
        },
        {
          title: "Previous",
          filter: (n) =>
            n.projectFocus == "System Innovation or Quality Improvement" &&
            n.sourceType == "Intramural" &&
            !isTodayWithinRange(n.time) &&
            !n.pending
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Other Intramural
    foint: {
      field: "projects",
      format: {
        t: ["fullMonthDayYear"],
        1: function (item, i, cvDef, genOpts = {}) {
          return [
            getText(item, "title"),
            getText(item, "grantTypeAndNumber"),
            getText(item, "fundingSource"),
            getText(item, "directCosts"),
            getText(item, "piName"),
            mergeItems([
              { key: "role" },
              { key: "workTime" },
              { key: "description" }
            ])(item, i, cvDef, genOpts)
          ]
            .filter((n) => n != "")
            .join(genOpts.noXML ? "<br>" : "\n");
        }
      },
      sectionsArray: [
        {
          title: "Current",
          filter: (n) =>
            n.projectFocus == "Other" &&
            n.sourceType == "Intramural" &&
            isTodayWithinRange(n.time)
        },
        {
          title: "Pending",
          filter: (n) =>
            n.projectFocus == "Other" &&
            n.sourceType == "Intramural" &&
            !!n.pending
        },
        {
          title: "Previous",
          filter: (n) =>
            n.projectFocus == "Other" &&
            n.sourceType == "Intramural" &&
            !isTodayWithinRange(n.time) &&
            !n.pending
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    fundIntTotal: {
      totals: [
        "frintTotal",
        "feintTotal",
        "fcintTotal",
        "fsiintTotal",
        "fointTotal"
      ]
    },
    // Clinical Activities
    ca: { field: "clinicalActivityAndInnovations" },
    caSection: {
      toggle: function (cvDef, filter, { customExportSettings }) {
        var emptySections =
          typeof customExportSettings != "undefined" &&
          customExportSettings.emptySections != null &&
          !!customExportSettings.emptySections;
        return (
          emptySections ||
          getField(cvDef, "clinicalActivityAndInnovations").filter(filter)
            .length > 0 ||
          cvDef?.researchInterests?.clinicalProductivity != null
        );
      }
    },
    // Clinical focus
    clfoc: {
      field: "researchInterests",
      xml: true,
      map: {
        ca_clinicalFocus: "clinicalFocus"
      }
    },
    // Certification
    cert: {
      section: "certification",
      field: "clinicalActivityAndInnovations",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems([
            { key: "title" },
            { key: "workTime" },
            { key: "description" }
          ]),
          "comments"
        ]
      },
      sectionsArray: [
        {
          type: "Current Licensure and Certification",
          title: "Medical, other state/government licensure"
        },
        {
          type: "certification",
          title: "Boards, other specialty certification"
        },
        {
          type: "Practice Activities",
          title: "Clinical (Service) Responsibilities"
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    cser: {
      section: "clinicalService",
      field: "clinicalActivityAndInnovations",
      type: "Practice Activities",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems([
            { key: "title" },
            { key: "workTime" },
            { key: "description" }
          ]),
          "comments"
        ]
      }
    },
    // Clinical Productivity
    clpr: {
      field: "researchInterests",
      xml: true,
      map: {
        ca_clinicalProductivity: "clinicalProductivity"
      }
    },
    // Clinical Activities
    clac: {
      section: "clinicalActivity",
      field: "clinicalActivityAndInnovations",
      preface: true,
      format: {
        t: function (item, i, cvDef, genOpts = {}) {
          if (item.type == "demonstrations")
            return getDate(item, "fullMonthDayYear", genOpts);
          return getDate(item, "fullMonthDayYear", genOpts);
        },
        1: [
          mergeItems([
            { key: "role" },
            { key: "title" },
            { key: "location" },
            { key: "description" }
          ]),
          "comments"
        ]
      },
      sectionsArray: [
        {
          type: "clinicalDraw",
          title: "Clinical Draw from outside local/regional area"
        },
        {
          type: "specialtyBoard",
          title: "Membership in or examiner for specialty board"
        },
        { type: "leadership", title: "Clinical Program Building / Leadership" },
        {
          type: "demonstrations",
          title:
            "Clinical Demonstration Activities to external audience, on or off campus"
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Develipment of clinical standards of care
    dcsc: {
      section: "ClinicalCareGuidelines",
      field: "clinicalActivityAndInnovations",
      type: "guidelines",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: ["line", "comments"]
      }
    },
    // Educational Activities
    edActSection: {
      toggle: function (cvDef, filter, { customExportSettings }) {
        var emptySections =
          typeof customExportSettings != "undefined" &&
          customExportSettings.emptySections != null &&
          !!customExportSettings.emptySections;
        return (
          emptySections ||
          getField(cvDef, "teaching")
            .filter(filter)
            .concat(getField(cvDef, "mentoring").filter(filter))
            .concat(
              getField(cvDef, "teachingAndEducationInnovations").filter(filter)
            ).length > 0
        );
      }
    },
    // Educational Focus
    edfoc: {
      field: "researchInterests",
      xml: true,
      map: {
        ed_educationalFocus: "teaching"
      }
    },
    // Teaching and Facilitating Learning
    tch: {
      section: "teachingAndFacilitatingLearning",
      field: "teaching",
      preface: true
    },
    // Classroom Instruction
    tch1: {
      section: "teachingAndFacilitatingLearning",
      field: "teaching",
      type: "Teaching of Students in Courses",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems([
            { key: "role" },
            { key: "learnerLevel" },
            { key: "title" },
            { key: "location" },
            { key: "numLearners" }
          ]),
          "comments"
        ]
      },
      sectionsArray: [
        {
          title: "Uncategorized",
          filter: (n) =>
            ["JHMI", "Regional", "National", "International"].indexOf(n.level) <
              0 && n.type == "Teaching of Students in Courses"
        },
        {
          title: "JHMI",
          filter: (n) =>
            n.level == "JHMI" && n.type == "Teaching of Students in Courses"
        },
        {
          title: "Regional",
          filter: (n) =>
            n.level == "Regional" && n.type == "Teaching of Students in Courses"
        },
        {
          title: "National",
          filter: (n) =>
            n.level == "National" && n.type == "Teaching of Students in Courses"
        },
        {
          title: "International",
          filter: (n) =>
            n.level == "International" &&
            n.type == "Teaching of Students in Courses"
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Clinical Instruction
    tch2: {
      section: "teachingAndFacilitatingLearning",
      field: "teaching",
      type: "Formal Teaching of Residents, Clinical Fellows and Research Fellows (post-docs)",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems([
            { key: "role" },
            { key: "learnerLevel" },
            { key: "title" },
            { key: "location" },
            { key: "numLearners" }
          ]),
          "comments"
        ]
      },
      sectionsArray: [
        {
          title: "Uncategorized",
          filter: (n) =>
            ["JHMI", "Regional", "National", "International"].indexOf(n.level) <
              0 &&
            n.type ==
              "Formal Teaching of Residents, Clinical Fellows and Research Fellows (post-docs)"
        },
        {
          title: "JHMI",
          filter: (n) =>
            n.level == "JHMI" &&
            n.type ==
              "Formal Teaching of Residents, Clinical Fellows and Research Fellows (post-docs)"
        },
        {
          title: "Regional",
          filter: (n) =>
            n.level == "Regional" &&
            n.type ==
              "Formal Teaching of Residents, Clinical Fellows and Research Fellows (post-docs)"
        },
        {
          title: "National",
          filter: (n) =>
            n.level == "National" &&
            n.type ==
              "Formal Teaching of Residents, Clinical Fellows and Research Fellows (post-docs)"
        },
        {
          title: "International",
          filter: (n) =>
            n.level == "International" &&
            n.type ==
              "Formal Teaching of Residents, Clinical Fellows and Research Fellows (post-docs)"
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // CME Instruction
    tch3: {
      section: "teachingAndFacilitatingLearning",
      field: "teaching",
      type: "Formal Teaching of Peers (e.g., CME and other continuing education courses)",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems([
            { key: "role" },
            { key: "learnerLevel" },
            { key: "title" },
            { key: "location" },
            { key: "numLearners" }
          ]),
          "comments"
        ]
      },
      sectionsArray: [
        {
          title: "Uncategorized",
          filter: (n) =>
            ["JHMI", "Regional", "National", "International"].indexOf(n.level) <
              0 &&
            n.type ==
              "Formal Teaching of Peers (e.g., CME and other continuing education courses)"
        },
        {
          title: "JHMI",
          filter: (n) =>
            n.level == "JHMI" &&
            n.type ==
              "Formal Teaching of Peers (e.g., CME and other continuing education courses)"
        },
        {
          title: "Regional",
          filter: (n) =>
            n.level == "Regional" &&
            n.type ==
              "Formal Teaching of Peers (e.g., CME and other continuing education courses)"
        },
        {
          title: "National",
          filter: (n) =>
            n.level == "National" &&
            n.type ==
              "Formal Teaching of Peers (e.g., CME and other continuing education courses)"
        },
        {
          title: "International",
          filter: (n) =>
            n.level == "International" &&
            n.type ==
              "Formal Teaching of Peers (e.g., CME and other continuing education courses)"
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Workshops / Seminars
    tch4: {
      section: "teachingAndFacilitatingLearning",
      field: "teaching",
      type: "external",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems([
            { key: "role" },
            { key: "learnerLevel" },
            { key: "title" },
            { key: "location" },
            { key: "numLearners" }
          ]),
          "comments"
        ]
      },
      sectionsArray: [
        {
          title: "Uncategorized",
          filter: (n) =>
            ["JHMI", "Regional", "National", "International"].indexOf(n.level) <
              0 && n.type == "external"
        },
        {
          title: "JHMI",
          filter: (n) => n.level == "JHMI" && n.type == "external"
        },
        {
          title: "Regional",
          filter: (n) => n.level == "Regional" && n.type == "external"
        },
        {
          title: "National",
          filter: (n) => n.level == "National" && n.type == "external"
        },
        {
          title: "International",
          filter: (n) => n.level == "International" && n.type == "external"
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    tchTotal: {
      totals: ["tch1Total", "tch2Total", "tch3Total", "tch4Total"]
    },
    // Mentoring, Coaching, Advising
    ment: {
      section: "mentees",
      field: "mentoring",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems([
            { key: "title" },
            { key: "position" },
            { key: "secondary" },
            { key: "description" },
            { key: "role" }
          ]),
          "comments"
        ]
      },
      sectionsArray: [
        { type: "undergraduate", title: "Pre-doctoral Advisees / Mentees" },
        { type: "postdoc", title: "Post-doctoral Advisees / Mentees" },
        { type: "graduate", title: "Thesis committees" }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Mentoring Programs
    ment2: {
      section: "mentoringCoachingProgram",
      field: "mentoring",
      type: "students",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems([
            { key: "description" },
            { key: "curriculum" },
            { key: "secondary" },
            { key: "effort" },
            { key: "location" }
          ]),
          "comments"
        ]
      },
      sectionsArray: [
        {
          title: "Uncategorized",
          filter: (n) =>
            ["JHMI", "Regional", "National", "International"].indexOf(n.level) <
              0 && n.type == "students"
        },
        {
          title: "JHMI",
          filter: (n) => n.level == "JHMI" && n.type == "students"
        },
        {
          title: "Regional",
          filter: (n) => n.level == "Regional" && n.type == "students"
        },
        {
          title: "National",
          filter: (n) => n.level == "National" && n.type == "students"
        },
        {
          title: "International",
          filter: (n) => n.level == "International" && n.type == "students"
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Assessment and Evaluation
    eda1: {
      section: "mentoringAndCoaching",
      field: "teachingAndEducationInnovations",
      type: "assessment",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems([
            { key: "role" },
            { key: "description" },
            { key: "numLearners" },
            { key: "location" },
            { key: "committee" },
            { key: "curriculum" }
          ]),
          "comments"
        ]
      },
      sectionsArray: [
        {
          title: "Uncategorized",
          filter: (n) =>
            ["JHMI", "Regional", "National", "International"].indexOf(n.level) <
              0 && n.type == "assessment"
        },
        {
          title: "JHMI",
          filter: (n) => n.level == "JHMI" && n.type == "assessment"
        },
        {
          title: "Regional",
          filter: (n) => n.level == "Regional" && n.type == "assessment"
        },
        {
          title: "National",
          filter: (n) => n.level == "National" && n.type == "assessment"
        },
        {
          title: "International",
          filter: (n) => n.level == "International" && n.type == "assessment"
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Program Building
    eda2: {
      section: "mentoringAndCoaching",
      field: "teachingAndEducationInnovations",
      type: "curriculum",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems([
            { key: "role" },
            { key: "description" },
            { key: "numLearners" },
            { key: "location" },
            { key: "committee" },
            { key: "curriculum" }
          ]),
          "comments"
        ]
      },
      sectionsArray: [
        {
          title: "Uncategorized",
          filter: (n) =>
            ["JHMI", "Regional", "National", "International"].indexOf(n.level) <
              0 && n.type == "curriculum"
        },
        {
          title: "JHMI",
          filter: (n) => n.level == "JHMI" && n.type == "curriculum"
        },
        {
          title: "Regional",
          filter: (n) => n.level == "Regional" && n.type == "curriculum"
        },
        {
          title: "National",
          filter: (n) => n.level == "National" && n.type == "curriculum"
        },
        {
          title: "International",
          filter: (n) => n.level == "International" && n.type == "curriculum"
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Educational Leadership
    eda3: {
      section: "mentoringAndCoaching",
      field: "teachingAndEducationInnovations",
      type: "leadership",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems([
            { key: "role" },
            { key: "description" },
            { key: "numLearners" },
            { key: "location" },
            { key: "committee" },
            { key: "curriculum" }
          ]),
          "comments"
        ]
      },
      sectionsArray: [
        {
          title: "Uncategorized",
          filter: (n) =>
            ["JHMI", "Regional", "National", "International"].indexOf(n.level) <
              0 && n.type == "leadership"
        },
        {
          title: "JHMI",
          filter: (n) => n.level == "JHMI" && n.type == "leadership"
        },
        {
          title: "Regional",
          filter: (n) => n.level == "Regional" && n.type == "leadership"
        },
        {
          title: "National",
          filter: (n) => n.level == "National" && n.type == "leadership"
        },
        {
          title: "International",
          filter: (n) => n.level == "International" && n.type == "leadership"
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Educational Demonstration Activities
    edda: {
      section: "externalDemonstration",
      field: "teachingAndEducationInnovations",
      type: "external",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems([
            { key: "title" },
            { key: "description" },
            { key: "location" }
          ]),
          "comments"
        ]
      }
    },
    // Research Activities
    resSection: {
      toggle: function (cvDef, filter, { customExportSettings }) {
        var emptySections =
          typeof customExportSettings != "undefined" &&
          customExportSettings.emptySections != null &&
          !!customExportSettings.emptySections;
        return (
          emptySections ||
          getField(cvDef, "technologyAndScienceInnovations").filter(filter)
            .length > 0 ||
          (cvDef.researchInterests != null &&
            cvDef.researchInterests.current != null &&
            cvDef.researchInterests.current.trim().length > 0)
        );
      }
    },
    // Research Focus
    rafoc: {
      field: "researchInterests",
      xml: true,
      map: {
        ra_researchFocus: "current"
      }
    },
    // Research Program Building, Research Demonstration, Patents, and Tech Transfer
    ra: {
      field: "technologyAndScienceInnovations",
      preface: true,
      format: {
        t: function (item, i, cvDef, genOpts = {}) {
          if (item.type == "activities")
            return getDate(item, "fullMonthDayYear", genOpts);
          return getDate(item, "fullMonthDayYear", genOpts);
        },
        1: [
          mergeItems([
            { key: "role" },
            { key: "title" },
            { key: "comments" },
            { key: "source" },
            { key: "location" }
          ]),
          "comments"
        ]
      },
      sectionsArray: [
        { type: "leadership", title: "Research Program Building / Leadership" },
        { type: "activities", title: "Research Demonstration Activities" },
        { type: "invention", title: "Inventions, Patents, Copyrights" },
        { type: "license", title: "Technology Transfer Activities" }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // System Innovation and QI
    // System Innovation Focus
    siFoc: {
      field: "researchInterests",
      xml: true,
      map: {
        si_systemInnovationFocus: "quality"
      }
    },
    // SI and QI efforts within and outside of JHMI, SI and QI Program Building / Leadership
    siqi: {
      section: "systemInnovationActivities",
      field: "clinicalActivityAndInnovations",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems([
            { key: "role" },
            { key: "title" },
            { key: "location" },
            { key: "results" }
          ]),
          "comments"
        ]
      },
      sectionsArray: [
        {
          type: "internal",
          title:
            "System Innovation and Quality Improvement efforts within JHMI:"
        },
        {
          type: "external",
          title:
            "System Innovation and Quality Improvement efforts outside of JHMI:"
        },
        {
          type: "QIleadership",
          title:
            "System Innovation and Quality Improvement Program Building/Leadership:"
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Organizational Activities
    orgActSection: {
      toggle: function (cvDef, filter, { customExportSettings }) {
        var emptySections =
          typeof customExportSettings != "undefined" &&
          customExportSettings.emptySections != null &&
          !!customExportSettings.emptySections;
        return (
          emptySections ||
          getField(cvDef, "adminService")
            .filter(filter)
            .concat(getField(cvDef, "editorialActivities").filter(filter))
            .concat(getField(cvDef, "grantReviewActivities").filter(filter))
            .concat(getField(cvDef, "societies").filter(filter))
            .concat(getField(cvDef, "meetingActivities").filter(filter))
            .concat(getField(cvDef, "otherPositions").filter(filter)).length > 0
        );
      }
    },
    // Institutional Administrative Appointments
    iaa: {
      field: "adminService",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [mergeItems([{ key: "title" }, { key: "location" }]), "comments"]
      }
    },
    // Editorial Activities
    ea: {
      field: "editorialActivities",
      format: {
        t: ["fullMonthDayYear"],
        1: [mergeItems([{ key: "role" }, { key: "journal" }]), "comments"]
      },
      sectionsArray: [
        { type: "board", title: "Editorial Board appointments" },
        {
          type: "Other Editorial Roles",
          title: "Journal peer review activities"
        },
        { type: "Ad hoc Reviewer", title: "Other peer review activities" }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Advisory Committees
    oaac: {
      field: "grantReviewActivities",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [mergeItems([{ key: "role" }, { key: "committee" }]), "comments"]
      }
    },
    // Professional Societies
    oaps: {
      field: "societies",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: ["space"],
        2: [mergeItems([{ key: "society" }, { key: "comments" }])]
      },
      sublist: {
        roles: {
          t: ["space"],
          1: ["fullMonthDayYear"],
          2: ["role"]
        }
      }
    },
    // Conference Organizer
    co: {
      section: "conference",
      field: "meetingActivities",
      type: "conference",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: ["location", "comments"]
      },
      sectionsArray: [
        {
          type: "conference",
          title: "Uncategorized",
          filter: (n) =>
            ["JHMI", "Regional", "National", "International"].indexOf(n.level) <
            0
        },
        { type: "conference", title: "JHMI", filter: (n) => n.level == "JHMI" },
        {
          type: "conference",
          title: "Regional",
          filter: (n) => n.level == "Regional"
        },
        {
          type: "conference",
          title: "National",
          filter: (n) => n.level == "National"
        },
        {
          type: "conference",
          title: "International",
          filter: (n) => n.level == "International"
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Session Chair
    sc: {
      section: "session",
      field: "meetingActivities",
      type: "session",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: ["location", "comments"]
      },
      sectionsArray: [
        {
          type: "session",
          title: "Uncategorized",
          filter: (n) =>
            ["JHMI", "Regional", "National", "International"].indexOf(n.level) <
            0
        },
        { type: "session", title: "JHMI", filter: (n) => n.level == "JHMI" },
        {
          type: "session",
          title: "Regional",
          filter: (n) => n.level == "Regional"
        },
        {
          type: "session",
          title: "National",
          filter: (n) => n.level == "National"
        },
        {
          type: "session",
          title: "International",
          filter: (n) => n.level == "International"
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Consultantships
    cs: {
      field: "otherPositions",
      type: "professional",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: ["location", "comments"]
      }
    },
    // Recognition
    recSection: {
      toggle: function (cvDef, filter, { customExportSettings }) {
        var emptySections =
          typeof customExportSettings != "undefined" &&
          customExportSettings.emptySections != null &&
          !!customExportSettings.emptySections;
        return (
          emptySections ||
          getField(cvDef, "honors")
            .filter(filter)
            .concat(getField(cvDef, "presentations").filter(filter)).length > 0
        );
      }
    },
    // Awards, Honors
    ah: {
      field: "honors",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems(
            [{ key: "title" }, { key: "description" }, { key: "location" }],
            {}
          ),
          "comments"
        ]
      }
    },
    // Invited Talks
    it: {
      field: "presentations",
      filter: (n) => n.invitedProfessorship == false,
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems([
            { key: "title" },
            { key: "sponsor" },
            { key: "location" }
          ]),
          "comments"
        ]
      },
      sectionsArray: [
        { key: "talksLocal", type: "local", title: "JHMI" },
        { key: "talksRegional", type: "regional", title: "Regional" },
        { key: "talksNational", type: "national", title: "National" },
        {
          key: "talksInternational",
          type: "international",
          title: "International"
        }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Visiting Professorships
    vp: {
      key: "visitingProf",
      field: "presentations",
      filter: (n) => n.invitedProfessorship == true,
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems([
            { key: "title" },
            { key: "sponsor" },
            { key: "location" }
          ]),
          "comments"
        ]
      }
    },
    // OTHER PROF ACCOMPLISHMENTS
    othAccSection: {
      toggle: function (cvDef, filter, { customExportSettings }) {
        var emptySections =
          typeof customExportSettings != "undefined" &&
          customExportSettings.emptySections != null &&
          !!customExportSettings.emptySections;
        return (
          emptySections ||
          getField(cvDef, "presentations")
            .filter(filter)
            .filter((n) => n.presType == "Poster" || n.presType == "Podium")
            .concat(getField(cvDef, "military").filter(filter))
            .concat(getField(cvDef, "community").filter(filter))
            .concat(getField(cvDef, "stanfordMore").filter(filter)).length > 0
        );
      }
    },
    // Posters
    pst: {
      key: "posters",
      field: "presentations",
      filter: (n) => n.presType == "Poster",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems([
            { key: "title" },
            { key: "sponsor" },
            { key: "location" }
          ]),
          "comments"
        ]
      }
    },
    // Oral Podium Presentations
    pod: {
      key: "oral",
      field: "presentations",
      filter: (n) => n.presType == "Podium",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems([
            { key: "title" },
            { key: "sponsor" },
            { key: "location" }
          ]),
          "comments"
        ]
      }
    },
    // Military Service
    mil: {
      field: "military",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: ["title", "comments"]
      }
    },
    // Community, Humanitarian, Philanthropic services
    chp: {
      field: "community",
      format: {
        t: ["fullMonthDayYear"],
        1: [
          mergeItems([
            { key: "title" },
            { key: "description" },
            { key: "location" }
          ]),
          "comments"
        ]
      },
      sectionsArray: [
        { type: "Activities", title: "Community Service" },
        { type: "humanitarian", title: "Humanitarian Activities" },
        { type: "philanthropy", title: "Philanthropic Activities" }
      ],
      sections: function (cvDef, genOpts, outputSettings) {
        return generateSectionsFromSectionsArray(this, cvDef, outputSettings);
      }
    },
    // Other
    oth: {
      field: "stanfordMore",
      preface: true,
      format: {
        t: ["fullMonthDayYear"],
        1: [mergeItems([{ key: "title" }, { key: "description" }]), "comments"]
      }
    }
  }
};
